export enum App {
  SEARCH = 'search',
  CABINET = 'cabinet',
  PASSENGERS = 'passengers',
  CUSTOMER_SUPPORT = 'customer-support',
}
